/**
 * @generated SignedSource<<0fae7c04394b34f654b6f553ef36d428>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LogoutUser",
    "kind": "LinkedField",
    "name": "logoutUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoutUserMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LogoutUserMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fd3a358b9988d1e20887aa3977588a91",
    "id": null,
    "metadata": {},
    "name": "LogoutUserMutation",
    "operationKind": "mutation",
    "text": "mutation LogoutUserMutation {\n  logoutUser {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "173db0014daf8fc4a151459395d60afa";

module.exports = node;
